// Complete Interactive Engine for Valkyrie 1-on-1 Clone on Drevit Dieren
document.addEventListener('DOMContentLoaded', () => {
  console.log('Valkyrie 1-on-1 Interactive Controller initialized.');

  // ==========================================
  // 1. FULL INTERACTIVE GALLERY SLIDER
  // ==========================================
  const slider = document.querySelector('#Slider-Gallery-template--30085304549711__main') || document.querySelector('.valkyrie-exact-container .product__media-list');
  const slides = document.querySelectorAll('#Slider-Gallery-template--30085304549711__main > .product__media-item, .valkyrie-exact-container .product__media-list > .product__media-item');
  const thumbs = document.querySelectorAll('#Slider-Thumbnails-template--30085304549711__main > .thumbnail-list__item, .valkyrie-exact-container .thumbnail-list > .thumbnail-list__item');
  const prevBtns = document.querySelectorAll('.vk-nav-prev, .slider-button--prev, .vk-arrow-prev');
  const nextBtns = document.querySelectorAll('.vk-nav-next, .slider-button--next, .vk-arrow-next');

  let currentSlideIndex = 0;
  const totalSlides = slides.length;

  function setActiveSlide(index) {
    if (index < 0) index = 0;
    if (index >= totalSlides) index = totalSlides - 1;
    currentSlideIndex = index;

    // Smoothly scroll the main slider to the target slide
    if (slides[index]) {
      slides[index].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    } else if (slider) {
      const slideWidth = slider.clientWidth;
      slider.scrollTo({
        left: index * slideWidth,
        behavior: 'smooth'
      });
    }

    // Update thumbnails
    thumbs.forEach((t, i) => {
      const btn = t.querySelector('button.thumbnail') || t;
      if (i === index) {
        t.classList.add('is-active');
        t.style.borderColor = '#2C6BB1';
        t.style.opacity = '1';
        btn.setAttribute('aria-current', 'true');
        if (index > 0) {
          t.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        } else {
          const thumbParent = t.closest('.thumbnail-slider, .thumbnail-list');
          if (thumbParent) thumbParent.scrollLeft = 0;
        }
      } else {
        t.classList.remove('is-active');
        t.style.borderColor = '#e2e8f0';
        t.style.opacity = '0.65';
        btn.removeAttribute('aria-current');
      }
    });

    // Update active slide class
    slides.forEach((s, i) => {
      if (i === index) {
        s.classList.add('is-active');
      } else {
        s.classList.remove('is-active');
      }
    });

    // Update dots
    const dots = document.querySelectorAll('.slider-counter__link--dots');
    dots.forEach((d, i) => {
      if (i === index) {
        d.classList.add('slider-counter__link--active');
      } else {
        d.classList.remove('slider-counter__link--active');
      }
    });
  }

  // Thumbnails click
  thumbs.forEach((thumb, idx) => {
    thumb.addEventListener('click', (e) => {
      e.preventDefault();
      setActiveSlide(idx);
    });
  });

  // Dots click
  const dots = document.querySelectorAll('.slider-counter__link--dots');
  dots.forEach((d, i) => {
    d.addEventListener('click', (e) => {
      e.preventDefault();
      setActiveSlide(i);
    });
  });

  // Next / Prev arrows click
  prevBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      setActiveSlide(currentSlideIndex - 1);
    });
  });
  nextBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      setActiveSlide(currentSlideIndex + 1);
    });
  });

  // Sync on manual swipe/scroll
  if (slider) {
    let scrollDebounce;
    slider.addEventListener('scroll', () => {
      clearTimeout(scrollDebounce);
      scrollDebounce = setTimeout(() => {
        const slideWidth = slider.clientWidth;
        if (slideWidth > 0) {
          const activeIndex = Math.round(slider.scrollLeft / slideWidth);
          if (activeIndex !== currentSlideIndex && activeIndex >= 0 && activeIndex < totalSlides) {
            currentSlideIndex = activeIndex;
            thumbs.forEach((t, i) => {
              const btn = t.querySelector('button.thumbnail') || t;
              if (i === activeIndex) {
                t.classList.add('is-active');
                t.style.borderColor = '#2C6BB1';
                t.style.opacity = '1';
                btn.setAttribute('aria-current', 'true');
              } else {
                t.classList.remove('is-active');
                t.style.borderColor = '#e2e8f0';
                t.style.opacity = '0.65';
                btn.removeAttribute('aria-current');
              }
            });
          }
        }
      }, 50);
    });
  }

  // Initialize first slide
  if (totalSlides > 0) {
    setActiveSlide(0);
  }

  // ==========================================
  // 2. BUNDLE & 4 FREE GIFTS CONTROLLER
  // ==========================================
  // 2. DREVIT SIZE GUIDE MODAL CONTROLLER
  // ==========================================
  const sizeModal = document.getElementById('DrevitSizeGuideModal');
  const sizeOpeners = document.querySelectorAll('.sizing-chart__button, #ProductPopup-Adm1qR2lOZVRJb3lwV__product_sizing_chart_rxU4YG');
  
  function openSizeModal() {
    if (!sizeModal) return;
    sizeModal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }

  function closeSizeModal() {
    if (!sizeModal) return;
    sizeModal.style.display = 'none';
    document.body.style.overflow = '';
  }

  sizeOpeners.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      openSizeModal();
    });
  });

  if (sizeModal) {
    const closeElements = sizeModal.querySelectorAll('.drevit-modal-close, .drevit-modal-close-btn, .drevit-modal-backdrop');
    closeElements.forEach(el => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        closeSizeModal();
      });
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && sizeModal.style.display === 'flex') {
        closeSizeModal();
      }
    });
  }

  // ==========================================
  // 3. BUNDLE & 4 FREE GIFTS CONTROLLER (Exact Competitor Valkyrie Logic)
  // ==========================================
  let selectedQty = 2; // Default 2x Buy 2
  const variantInput = document.querySelector('input[name="id"].product-variant-id, input[name="id"]');
  const bundleCards = document.querySelectorAll('.vk-bundle-option, .vk-bundle-card');
  const atcTextEl = document.querySelector('.vk-button-text, .vk-atc-text, .main-atc__label__text');
  const savingsTextEl = document.querySelector('.vk-savings-text, .vk-savings-amount-text');
  const giftCard3 = document.querySelector('.vk-gift-3');
  const giftCard4 = document.querySelector('.vk-gift-4');

  const dropdownWrap1 = document.querySelector('.vk-size-dropdown-wrap-1, .vk-tier1-dropdown');
  const dropdownWrap2 = document.querySelector('.vk-size-dropdown-wrap-2, .vk-tier2-dropdown');
  const select1 = document.querySelector('.vk-bundle-select-1, .vk-select-1');
  const select2a = document.querySelector('.vk-bundle-select-2a, .vk-select-2a');
  const select2b = document.querySelector('.vk-bundle-select-2b, .vk-select-2b');

  
  // Dynamic price calculation based on variant selection
  function updateTier1Price() {
    const selOpt = select1 ? select1.options[select1.selectedIndex] : null;
    const price = selOpt ? parseFloat(selOpt.getAttribute('data-price') || '58.95') : 58.95;
    const compare = price >= 64 ? 94.00 : (price >= 62 ? 89.00 : 84.00);
    const priceTier1 = document.querySelector('.vk-price-tier-1');
    if (priceTier1) priceTier1.textContent = '€' + price.toFixed(2).replace('.', ',');
    if (selectedQty === 1) {
      const stickyPriceDisplay = document.getElementById('vk-sticky-price-display');
      const stickyCompareDisplay = document.getElementById('vk-sticky-compare-display');
      if (stickyPriceDisplay) stickyPriceDisplay.textContent = '€' + price.toFixed(2).replace('.', ',');
      if (stickyCompareDisplay) stickyCompareDisplay.textContent = '€' + compare.toFixed(2).replace('.', ',');
    }
  }

  function updateTier2Price() {
    const optA = select2a ? select2a.options[select2a.selectedIndex] : null;
    const optB = select2b ? select2b.options[select2b.selectedIndex] : null;
    const pA = optA ? parseFloat(optA.getAttribute('data-price') || '62.95') : 62.95;
    const pB = optB ? parseFloat(optB.getAttribute('data-price') || '62.95') : 62.95;
    const cA = pA >= 64 ? 94.00 : (pA >= 62 ? 89.00 : 84.00);
    const cB = pB >= 64 ? 94.00 : (pB >= 62 ? 89.00 : 84.00);

    const totalPrice = (pA + pB) * 0.85;
    const totalCompare = cA + cB;

    const priceTier2 = document.querySelector('.vk-price-tier-2');
    const compareTier2 = document.querySelector('.vk-compare-tier-2');
    if (priceTier2) priceTier2.textContent = '€' + totalPrice.toFixed(2).replace('.', ',');
    if (compareTier2) compareTier2.textContent = '€' + totalCompare.toFixed(2).replace('.', ',');

    if (selectedQty === 2) {
      const stickyPriceDisplay = document.getElementById('vk-sticky-price-display');
      const stickyCompareDisplay = document.getElementById('vk-sticky-compare-display');
      if (stickyPriceDisplay) stickyPriceDisplay.textContent = '€' + totalPrice.toFixed(2).replace('.', ',');
      if (stickyCompareDisplay) stickyCompareDisplay.textContent = '€' + totalCompare.toFixed(2).replace('.', ',');
    }
  }

  function updateBundleState(qty) {
    selectedQty = qty;

    bundleCards.forEach(card => {
      const q = parseInt(card.getAttribute('data-qty'), 10);
      if (q === qty) {
        card.classList.add('active');
        card.style.border = '2px solid #2C6BB1';
        card.style.background = '#ffffff';
        card.style.boxShadow = 'none';
      } else {
        card.classList.remove('active');
        card.style.border = '1px solid rgba(44, 107, 177, 0.3)';
        card.style.background = '#ededed';
        card.style.boxShadow = 'none';
      }
    });

    if (qty === 1) {
      if (dropdownWrap1) dropdownWrap1.style.display = 'flex';
      if (dropdownWrap2) dropdownWrap2.style.display = 'none';

      if (atcTextEl) atcTextEl.innerHTML = 'IN WINKELWAGEN &ndash; BESPAAR €25';
      if (savingsTextEl) savingsTextEl.innerHTML = 'Je bespaart vandaag <strong>€24,05</strong> op deze bestelling!';

      const stickyPriceDisplay = document.getElementById('vk-sticky-price-display');
      const stickyCompareDisplay = document.getElementById('vk-sticky-compare-display');
      if (stickyPriceDisplay) stickyPriceDisplay.textContent = '€58,95';
      if (stickyCompareDisplay) stickyCompareDisplay.textContent = '€83,00';

      if (giftCard3) {
        giftCard3.style.opacity = '0.5';
        giftCard3.style.filter = 'grayscale(60%)';
        const st = giftCard3.querySelector('.vk-gift-status-3');
        if (st) { st.textContent = '🔒 BIJ 2+'; st.style.background = '#64748b'; }
      }
      if (giftCard4) {
        giftCard4.style.opacity = '0.5';
        giftCard4.style.filter = 'grayscale(60%)';
        const st = giftCard4.querySelector('.vk-gift-status-4');
        if (st) { st.textContent = '🔒 BIJ 2+'; st.style.background = '#64748b'; }
      }

      if (select1 && variantInput) {
        variantInput.value = select1.value;
      }
      updateTier1Price();
    } else {
      if (dropdownWrap1) dropdownWrap1.style.display = 'none';
      if (dropdownWrap2) dropdownWrap2.style.display = 'flex';

      if (atcTextEl) atcTextEl.innerHTML = 'IN WINKELWAGEN &ndash; BESPAAR €40';
      if (savingsTextEl) savingsTextEl.innerHTML = 'Je bespaart vandaag <strong>€17,68 extra</strong> op deze bestelling!';

      const stickyPriceDisplay = document.getElementById('vk-sticky-price-display');
      const stickyCompareDisplay = document.getElementById('vk-sticky-compare-display');
      if (stickyPriceDisplay) stickyPriceDisplay.textContent = '€100,22';
      if (stickyCompareDisplay) stickyCompareDisplay.textContent = '€140,22';

      if (giftCard3) {
        giftCard3.style.opacity = '1';
        giftCard3.style.filter = 'none';
        const st = giftCard3.querySelector('.vk-gift-status-3');
        if (st) { st.textContent = 'GRATIS €23,95'; st.style.background = '#2C6BB1'; }
      }
      if (giftCard4) {
        giftCard4.style.opacity = '1';
        giftCard4.style.filter = 'none';
        const st = giftCard4.querySelector('.vk-gift-status-4');
        if (st) { st.textContent = 'GRATIS €20,00'; st.style.background = '#2C6BB1'; }
      }

      if (select2a && variantInput) {
        variantInput.value = select2a.value;
      }
      updateTier2Price();
    }
  }

  bundleCards.forEach(card => {
    card.addEventListener('click', (e) => {
      if (e.target.tagName === 'SELECT' || e.target.tagName === 'OPTION') return;
      const q = parseInt(card.getAttribute('data-qty'), 10) || 1;
      updateBundleState(q);
    });
  });

  if (select1) {
    select1.addEventListener('change', () => {
      if (selectedQty === 1 && variantInput) {
        variantInput.value = select1.value;
      }
      updateTier1Price();
    });
  }
  if (select2a) {
    select2a.addEventListener('change', () => {
      if (selectedQty === 2 && variantInput) {
        variantInput.value = select2a.value;
      }
      updateTier2Price();
    });
  }
  if (select2b) {
    select2b.addEventListener('change', () => {
      updateTier2Price();
    });
  }

  // Set default state (2x)
  updateBundleState(2);

  // ==========================================
  // 4. ADD TO CART INTERCEPTOR
  // ==========================================
  function executeBundleAddToCart() {
    const mainSubmitBtn = document.querySelector('form.vk-bundle-form [type="submit"], .vk-submit-atc, button[name="add"], #SectionAtcBtn-template--30085304549711__main');
    const stickySubmitBtn = document.getElementById('vk-sticky-submit-btn');

    const originalMainText = mainSubmitBtn ? mainSubmitBtn.innerHTML : 'IN WINKELWAGEN &ndash; BESPAAR €40';
    if (mainSubmitBtn) {
      mainSubmitBtn.disabled = true;
      mainSubmitBtn.innerHTML = '<span>Toevoegen aan winkelwagen...</span>';
    }
    if (stickySubmitBtn) {
      stickySubmitBtn.disabled = true;
      stickySubmitBtn.innerHTML = '<span class="vk-sticky-btn-text">Toevoegen...</span>';
    }

    const BUNDLE_2X_VARIANTS = {
      'Small|Small': '55719060930899',
      'Small|Medium': '55719061422419',
      'Small|Large': '55719061455187',
      'Medium|Small': '55719061487955',
      'Medium|Medium': '55719061717331',
      'Medium|Large': '55719061750099',
      'Large|Small': '55719062045011',
      'Large|Medium': '55719062569299',
      'Large|Large': '55719062602067'
    };
    const SIZE_BY_VID = {
      '54882139439443': 'Small',
      '54882139472211': 'Medium',
      '54882139504979': 'Large'
    };

    let cartItems = [];
    if (selectedQty === 1) {
      const v1 = select1 ? select1.value : (variantInput ? variantInput.value : '54882139439443');
      const sz1 = SIZE_BY_VID[String(v1)] || 'Small';
      cartItems.push({ 
        id: v1, 
        quantity: 1,
        properties: {
          '_bundel': '1x Kopen (30% Korting)',
          'Maat': sz1,
          'Inbegrepen Cadeaus': 'Voetpomp + Breinspeeltje'
        }
      });
    } else {
      const vA = select2a ? select2a.value : (variantInput ? variantInput.value : '54882139439443');
      const vB = select2b ? select2b.value : (variantInput ? variantInput.value : '54882139472211');
      const szA = SIZE_BY_VID[String(vA)] || 'Small';
      const szB = SIZE_BY_VID[String(vB)] || 'Medium';
      const bundleVarId = BUNDLE_2X_VARIANTS[szA + '|' + szB] || '55719061422419';
      cartItems.push({ 
        id: bundleVarId, 
        quantity: 1,
        properties: {
          '_bundel': '2x Kopen – Blije Honden Bundel (Extra 15% Korting)',
          'Bal #1': szA,
          'Bal #2': szB,
          'Inbegrepen Cadeaus': 'Voetpomp, Breinspeeltje, E-Book Gids, €20 Cadeaubon'
        }
      });
    }

    // Check existing cart items first to prevent duplicate free gifts and auto-include guide upsell
    fetch('/cart.js')
      .then(r => r.json())
      .catch(() => ({ items: [] }))
      .then(cartData => {
        const existingIds = new Set((cartData.items || []).map(item => String(item.id || item.variant_id)));

        // 1. Auto-include Drijfbal Trainingsgids (€4,95) if not already in cart
        const GUIDE_VARIANT_ID = '54929139564883';
        if (!existingIds.has(GUIDE_VARIANT_ID)) {
          cartItems.push({
            id: GUIDE_VARIANT_ID,
            quantity: 1,
            properties: { '_is_guide_upsell': 'true' }
          });
        }

        // 2. Add Free Gift Product Variants ONLY if not already present (strictly 1 of each)
        const GIFT_PUMP_ID = '54882144223571'; // Handige Voetpomp
        const GIFT_TOY_ID = '54882160378195';  // Interactief Breinspeeltje
        const GIFT_EBOOK_ID = '54902781509971'; // IJsjes Recepten Gids (E-Book)
        const GIFT_CARD_ID = '54902767223123';  // €20 Waardebon

        if (!existingIds.has(GIFT_PUMP_ID)) {
          cartItems.push({ id: GIFT_PUMP_ID, quantity: 1, properties: { '_is_free_gift': 'true' } });
        }
        if (!existingIds.has(GIFT_TOY_ID)) {
          cartItems.push({ id: GIFT_TOY_ID, quantity: 1, properties: { '_is_free_gift': 'true' } });
        }
        if (selectedQty >= 2) {
          if (!existingIds.has(GIFT_EBOOK_ID)) {
            cartItems.push({ id: GIFT_EBOOK_ID, quantity: 1, properties: { '_is_free_gift': 'true' } });
          }
          if (!existingIds.has(GIFT_CARD_ID)) {
            cartItems.push({ id: GIFT_CARD_ID, quantity: 1, properties: { '_is_free_gift': 'true' } });
          }
        }

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: cartItems })
        });
      })
    .then(res => res.json())
    .then(data => {
      if (mainSubmitBtn) mainSubmitBtn.innerHTML = '<span>Toegevoegd! ✓</span>';
      if (stickySubmitBtn) stickySubmitBtn.innerHTML = '<span class="vk-sticky-btn-text">Toegevoegd! ✓</span>';

      setTimeout(() => {
        if (typeof window.openValkyrieCartDrawer === 'function') {
          window.openValkyrieCartDrawer();
        } else if (typeof window.openCartDrawer === 'function') {
          window.openCartDrawer();
        } else {
          window.location.href = '/cart';
        }
        if (mainSubmitBtn) {
          mainSubmitBtn.disabled = false;
          mainSubmitBtn.innerHTML = originalMainText;
        }
        if (stickySubmitBtn) {
          stickySubmitBtn.disabled = false;
          stickySubmitBtn.innerHTML = '<span class="vk-sticky-btn-text">In winkelwagen</span>';
        }
      }, 300);
    })
    .catch(err => {
      console.error('Error adding to cart:', err);
      if (mainSubmitBtn) {
        mainSubmitBtn.disabled = false;
        mainSubmitBtn.innerHTML = originalMainText;
      }
      if (stickySubmitBtn) {
        stickySubmitBtn.disabled = false;
        stickySubmitBtn.innerHTML = '<span class="vk-sticky-btn-text">In winkelwagen</span>';
      }
      if (typeof window.openValkyrieCartDrawer === 'function') {
        window.openValkyrieCartDrawer();
      } else {
        window.location.href = '/cart';
      }
    });
  }

  const form = document.querySelector('form.vk-bundle-form, form[action*="/cart/add"]');
  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      executeBundleAddToCart();
    });
  }

  const mainAtcBtns = document.querySelectorAll('.vk-submit-atc, #ProductSubmitButton-template--30085304549711__main, #SectionAtcBtn-template--30085304549711__main');
  mainAtcBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      executeBundleAddToCart();
    });
  });

  // ==========================================
  // STICKY ATC BAR CONTROLLER (1-ON-1 VALKYRIE)
  // ==========================================
  const stickyAtcBar = document.getElementById('vk-clean-sticky-atc');
  if (stickyAtcBar) {
    if (stickyAtcBar.parentElement !== document.body) {
      document.body.appendChild(stickyAtcBar);
    }

    const stickySubmitBtn = document.getElementById('vk-sticky-submit-btn');
    if (stickySubmitBtn) {
      stickySubmitBtn.addEventListener('click', (e) => {
        e.preventDefault();
        executeBundleAddToCart();
      });
    }

    const mainBuyBtn = document.getElementById('ProductSubmitButton-template--30085304549711__main') ||
                       document.querySelector('.main-product-atc, button[name="add"], .atc-button');

    const checkStickyScroll = () => {
      if (mainBuyBtn) {
        const boxRect = mainBuyBtn.getBoundingClientRect();
        // Show when main buy button scrolls off the top of the viewport
        if (boxRect.bottom < 15) {
          stickyAtcBar.classList.add('show');
          stickyAtcBar.setAttribute('aria-hidden', 'false');
        } else {
          stickyAtcBar.classList.remove('show');
          stickyAtcBar.setAttribute('aria-hidden', 'true');
        }
      } else {
        if (window.scrollY > 600) {
          stickyAtcBar.classList.add('show');
          stickyAtcBar.setAttribute('aria-hidden', 'false');
        } else {
          stickyAtcBar.classList.remove('show');
          stickyAtcBar.setAttribute('aria-hidden', 'true');
        }
      }
    };

    window.addEventListener('scroll', checkStickyScroll, { passive: true });
    window.addEventListener('resize', checkStickyScroll, { passive: true });
    window.addEventListener('touchmove', checkStickyScroll, { passive: true });
    checkStickyScroll();
  }

  // ==========================================
  // 5. COUNTDOWN TIMER
  // ==========================================
  let totalSeconds = 7200; // 2 hours
  setInterval(() => {
    totalSeconds--;
    if (totalSeconds < 0) totalSeconds = 7200;
    const h = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
    const m = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
    const s = String(totalSeconds % 60).padStart(2, '0');

    const hEls = document.querySelectorAll('#h, #vk-hours');
    const mEls = document.querySelectorAll('#m, #vk-mins');
    const sEls = document.querySelectorAll('#s, #vk-secs');
    hEls.forEach(el => el.textContent = h);
    mEls.forEach(el => el.textContent = m);
    sEls.forEach(el => el.textContent = s);
  }, 1000);

  // ==========================================
  // 6. DYNAMIC SHIPPING DATES (DUTCH)
  // ==========================================
  const dynamicDateEls = document.querySelectorAll('[data-dynamic-date], .estimated-shipping__text');
  if (dynamicDateEls.length > 0) {
    const monthsNL = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];
    const daysNL = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];

    const now = new Date();
    const startDate = new Date();
    startDate.setDate(now.getDate() + 2);
    if (startDate.getDay() === 0) startDate.setDate(startDate.getDate() + 1);

    const endDate = new Date();
    endDate.setDate(startDate.getDate() + 2);
    if (endDate.getDay() === 0) endDate.setDate(endDate.getDate() + 1);

    const startFormatted = `${daysNL[startDate.getDay()]} ${startDate.getDate()} ${monthsNL[startDate.getMonth()]}`;
    const endFormatted = `${daysNL[endDate.getDay()]} ${endDate.getDate()} ${monthsNL[endDate.getMonth()]}`;

    const isNL = window.location.hostname.includes('.nl');
    const carrierText = isNL ? 'via <strong>PostNL</strong>' : 'via <strong>PostNL</strong> (NL) of <strong>Bpost</strong> (BE)';

    dynamicDateEls.forEach(el => {
      el.innerHTML = `<p style="margin: 0 !important; font-size: 13.5px !important; line-height: 1.4 !important; color: #475569 !important;">Verwachte bezorging: <strong style="color: #0f172a !important; font-size: 13.5px !important;">${startFormatted} - ${endFormatted}</strong> ${carrierText} 📦</p>`;
    });
  }

  // ==========================================
  // 6b. FAQ ACCORDION TOGGLE CONTROLLER
  // ==========================================
  const faqAccordions = document.querySelectorAll('.product__accordion');
  faqAccordions.forEach(acc => {
    const summary = acc.querySelector('.accordion__summary');
    const details = acc.querySelector('details');
    const content = acc.querySelector('.accordion__content-wrapper');
    if (summary && content) {
      summary.addEventListener('click', (e) => {
        e.preventDefault();
        const isOpen = acc.classList.contains('is-open') || (details && details.hasAttribute('open'));
        if (isOpen) {
          acc.classList.remove('is-open');
          if (details) details.removeAttribute('open');
          content.style.display = 'none';
        } else {
          acc.classList.add('is-open');
          if (details) details.setAttribute('open', '');
          content.style.display = 'block';
        }
      });
    }
  });

  // ==========================================
  // 7. REVIEW SLIDER CONTROLLER (3 DUTCH REVIEWS, FULL SWIPE & DRAG)
  // ==========================================
  const reviewSplides = document.querySelectorAll('.vk-review-splide, splide-component:has(.review-item)');
  reviewSplides.forEach(reviewSplide => {
    const list = reviewSplide.querySelector('.splide__list');
    const slides = reviewSplide.querySelectorAll('.splide__slide');
    if (!list || slides.length === 0) return;

    const track = reviewSplide.querySelector('.splide__track') || list.parentElement;
    const pagination = reviewSplide.querySelector('.splide__pagination');
    let reviewIndex = 0;
    const totalReviews = slides.length;

    track.style.overflow = 'hidden';
    track.style.width = '100%';
    track.style.position = 'relative';
    track.style.cursor = 'grab';
    track.style.touchAction = 'pan-y';

    list.style.display = 'flex';
    list.style.width = '100%';
    list.style.padding = '0';
    list.style.margin = '0';
    list.style.listStyle = 'none';
    list.style.transition = 'transform 0.35s cubic-bezier(0.25, 1, 0.5, 1)';

    slides.forEach(s => {
      s.style.flex = '0 0 100%';
      s.style.minWidth = '100%';
      s.style.maxWidth = '100%';
      s.style.boxSizing = 'border-box';
      s.style.userSelect = 'none';
      s.style.webkitUserSelect = 'none';
    });

    function updatePagination() {
      if (!pagination) return;
      const dots = pagination.querySelectorAll('.splide__pagination__page');
      dots.forEach((d, i) => {
        if (i === reviewIndex) {
          d.classList.add('is-active');
          d.style.backgroundColor = '#0f172a';
          d.style.transform = 'scale(1.25)';
        } else {
          d.classList.remove('is-active');
          d.style.backgroundColor = '#cbd5e1';
          d.style.transform = 'scale(1)';
        }
      });
    }

    function getSlideOffset(idx) {
      if (!slides || slides.length === 0) return 0;
      const firstSlide = slides[0];
      const targetSlide = slides[idx] || firstSlide;
      return targetSlide.offsetLeft - firstSlide.offsetLeft;
    }

    function goToReview(idx, animate = true) {
      if (idx < 0) idx = 0;
      if (idx >= totalReviews) idx = totalReviews - 1;
      reviewIndex = idx;
      if (animate) {
        list.style.transition = 'transform 0.35s cubic-bezier(0.25, 1, 0.5, 1)';
      } else {
        list.style.transition = 'none';
      }
      const offset = getSlideOffset(reviewIndex);
      list.style.transform = `translateX(-${offset}px)`;
      updatePagination();
    }

    // Populate dots
    if (pagination) {
      pagination.innerHTML = '';
      pagination.style.display = 'flex';
      pagination.style.justifyContent = 'center';
      pagination.style.alignItems = 'center';
      pagination.style.gap = '8px';
      pagination.style.marginTop = '14px';
      pagination.style.listStyle = 'none';
      pagination.style.padding = '0';

      for (let i = 0; i < totalReviews; i++) {
        const li = document.createElement('li');
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.setAttribute('aria-label', `Review ${i + 1}`);
        btn.className = 'splide__pagination__page' + (i === 0 ? ' is-active' : '');
        btn.style.width = '9px';
        btn.style.height = '9px';
        btn.style.borderRadius = '50%';
        btn.style.border = 'none';
        btn.style.cursor = 'pointer';
        btn.style.padding = '0';
        btn.style.backgroundColor = i === 0 ? '#0f172a' : '#cbd5e1';
        btn.style.transition = 'all 0.3s ease';
        btn.style.transform = i === 0 ? 'scale(1.25)' : 'scale(1)';

        btn.addEventListener('click', (e) => {
          e.preventDefault();
          goToReview(i);
        });
        li.appendChild(btn);
        pagination.appendChild(li);
      }
      goToReview(0, false);
    }

    // Recalculate on window resize
    window.addEventListener('resize', () => {
      goToReview(reviewIndex, false);
    });

    // ==========================================
    // INTERACTIVE REAL-TIME SWIPE & DRAG CONTROLLER
    // ==========================================
    let isDragging = false;
    let startX = 0;
    let startY = 0;
    let currentX = 0;
    let currentY = 0;
    let dragDistance = 0;
    let isHorizontalSwipe = null;
    let autoTimer = null;

    function startDrag(clientX, clientY) {
      isDragging = true;
      startX = clientX;
      startY = clientY;
      currentX = clientX;
      currentY = clientY;
      dragDistance = 0;
      isHorizontalSwipe = null;
      track.style.cursor = 'grabbing';
      list.style.transition = 'none';
      clearInterval(autoTimer);
    }

    function moveDrag(clientX, clientY, e) {
      if (!isDragging) return;
      currentX = clientX;
      currentY = clientY;
      const deltaX = currentX - startX;
      const deltaY = currentY - startY;

      if (isHorizontalSwipe === null) {
        if (Math.abs(deltaX) > 4 || Math.abs(deltaY) > 4) {
          isHorizontalSwipe = Math.abs(deltaX) > Math.abs(deltaY);
        }
      }

      if (isHorizontalSwipe) {
        if (e && e.cancelable) e.preventDefault();
        dragDistance = deltaX;
        const currentOffset = -getSlideOffset(reviewIndex);

        // Dampen edges
        let adjustedDelta = deltaX;
        if ((reviewIndex === 0 && deltaX > 0) || (reviewIndex === totalReviews - 1 && deltaX < 0)) {
          adjustedDelta = deltaX * 0.3;
        }

        list.style.transform = `translateX(${currentOffset + adjustedDelta}px)`;
      }
    }

    function endDrag() {
      if (!isDragging) return;
      isDragging = false;
      track.style.cursor = 'grab';
      list.style.transition = 'transform 0.35s cubic-bezier(0.25, 1, 0.5, 1)';

      const threshold = 40;

      if (dragDistance < -threshold && reviewIndex < totalReviews - 1) {
        goToReview(reviewIndex + 1);
      } else if (dragDistance > threshold && reviewIndex > 0) {
        goToReview(reviewIndex - 1);
      } else {
        goToReview(reviewIndex); // snap back
      }
    }

    // Touch events (Mobile swipe)
    track.addEventListener('touchstart', (e) => {
      if (e.touches.length === 1) {
        startDrag(e.touches[0].clientX, e.touches[0].clientY);
      }
    }, { passive: true });

    track.addEventListener('touchmove', (e) => {
      if (e.touches.length === 1) {
        moveDrag(e.touches[0].clientX, e.touches[0].clientY, e);
      }
    }, { passive: false });

    track.addEventListener('touchend', endDrag, { passive: true });
    track.addEventListener('touchcancel', endDrag, { passive: true });

    // Mouse drag events (Desktop mouse drag/swipe)
    track.addEventListener('mousedown', (e) => {
      if (e.button !== 0) return;
      startDrag(e.clientX, e.clientY);
      e.preventDefault();
    });

    window.addEventListener('mousemove', (e) => {
      if (isDragging) {
        moveDrag(e.clientX, e.clientY, e);
      }
    });

    window.addEventListener('mouseup', (e) => {
      if (isDragging) {
        endDrag();
      }
    });

    // Prevent clicking links/buttons if user was dragging
    track.addEventListener('click', (e) => {
      if (Math.abs(dragDistance) > 6) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
  });

  // ==========================================
  // 8. TIMELINE TABS CONTROLLER (#1 Meest Verkochte Drijfbal)
  // ==========================================
  const contentTabsComponents = document.querySelectorAll('content-tabs');
  contentTabsComponents.forEach(component => {
    const buttons = component.querySelectorAll('.content-tab-button-js');
    const tabs = component.querySelectorAll('.content-tab');

    function switchTab(index) {
      buttons.forEach(btn => {
        const btnIdx = btn.getAttribute('data-index');
        const span = btn.querySelector('span');
        if (btnIdx === String(index)) {
          btn.classList.add('content-tab-button--active');
          btn.style.setProperty('background', '#0f172a', 'important');
          btn.style.setProperty('color', '#ffffff', 'important');
          if (span) span.style.setProperty('color', '#ffffff', 'important');
        } else {
          btn.classList.remove('content-tab-button--active');
          btn.style.setProperty('background', 'transparent', 'important');
          btn.style.setProperty('color', '#0f172a', 'important');
          if (span) span.style.setProperty('color', '#0f172a', 'important');
        }
      });

      tabs.forEach(tab => {
        const tabIdx = tab.getAttribute('data-index');
        if (tabIdx === String(index)) {
          tab.classList.add('content-tab--active');
          tab.style.display = '';
          tab.style.opacity = '1';
        } else {
          tab.classList.remove('content-tab--active');
          tab.style.display = 'none';
          tab.style.opacity = '0';
        }
      });
    }

    buttons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const idx = btn.getAttribute('data-index');
        switchTab(idx);
      });
    });

    const initialActiveBtn = component.querySelector('.content-tab-button--active') || buttons[0];
    if (initialActiveBtn) {
      switchTab(initialActiveBtn.getAttribute('data-index') || 0);
    }
  });

  // ==========================================
  // 9. DREVIT VIDEO CAROUSEL CONTROLLER ("ZIE DE DRIJFBAL IN ACTIE")
  // ==========================================
  const videoSplides = document.querySelectorAll('.drevit-video-splide-component, splide-component:has(.drevit-video-card)');
  videoSplides.forEach(videoSplide => {
    const track = videoSplide.querySelector('.splide__track');
    const list = videoSplide.querySelector('.splide__list');
    const slides = Array.from(videoSplide.querySelectorAll('.splide__slide'));
    const prevBtn = videoSplide.querySelector('.drevit-video-arrow--prev');
    const nextBtn = videoSplide.querySelector('.drevit-video-arrow--next');
    const pagination = videoSplide.querySelector('.drevit-video-pagination');

    if (!track || !list || slides.length === 0) return;

    let currentIndex = 0;
    const totalSlides = slides.length;

    function getSlidesPerView() {
      return window.innerWidth >= 750 ? 3 : 2;
    }

    function getMaxIndex() {
      return Math.max(0, totalSlides - getSlidesPerView());
    }

    function getSlideOffset(idx) {
      if (!slides[idx]) return 0;
      const firstSlide = slides[0];
      const targetSlide = slides[idx];
      return targetSlide.offsetLeft - firstSlide.offsetLeft;
    }

    function updateControls() {
      const maxIdx = getMaxIndex();
      if (prevBtn) {
        if (currentIndex <= 0) {
          prevBtn.classList.add('is-disabled');
        } else {
          prevBtn.classList.remove('is-disabled');
        }
      }
      if (nextBtn) {
        if (currentIndex >= maxIdx) {
          nextBtn.classList.add('is-disabled');
        } else {
          nextBtn.classList.remove('is-disabled');
        }
      }

      // Update dots
      if (pagination) {
        const dots = pagination.querySelectorAll('.drevit-video-dot');
        dots.forEach((dot, i) => {
          if (i === currentIndex) {
            dot.classList.add('is-active');
          } else {
            dot.classList.remove('is-active');
          }
        });
      }
    }

    function goToIndex(idx, animate = true) {
      const maxIdx = getMaxIndex();
      if (idx < 0) idx = 0;
      if (idx > maxIdx) idx = maxIdx;
      currentIndex = idx;

      if (animate) {
        list.style.transition = 'transform 0.35s cubic-bezier(0.25, 1, 0.5, 1)';
      } else {
        list.style.transition = 'none';
      }

      const offset = getSlideOffset(currentIndex);
      list.style.transform = `translateX(-${offset}px)`;
      updateControls();
    }

    function buildDots() {
      if (!pagination) return;
      pagination.innerHTML = '';
      const totalDots = getMaxIndex() + 1;

      for (let i = 0; i < totalDots; i++) {
        const li = document.createElement('li');
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'drevit-video-dot' + (i === currentIndex ? ' is-active' : '');
        dot.setAttribute('aria-label', `Video slide ${i + 1}`);

        dot.addEventListener('click', (e) => {
          e.preventDefault();
          goToIndex(i);
        });

        li.appendChild(dot);
        pagination.appendChild(li);
      }
    }

    // Arrow navigation
    if (prevBtn) {
      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        goToIndex(currentIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        goToIndex(currentIndex + 1);
      });
    }

    // Touch and mouse drag swipe
    let isDragging = false;
    let startX = 0;
    let startY = 0;
    let currentX = 0;
    let currentY = 0;
    let dragDistance = 0;
    let isHorizontalSwipe = null;

    function startDrag(clientX, clientY) {
      isDragging = true;
      startX = clientX;
      startY = clientY;
      currentX = clientX;
      currentY = clientY;
      dragDistance = 0;
      isHorizontalSwipe = null;
      track.style.cursor = 'grabbing';
      list.style.transition = 'none';
    }

    function moveDrag(clientX, clientY, e) {
      if (!isDragging) return;
      currentX = clientX;
      currentY = clientY;
      const deltaX = currentX - startX;
      const deltaY = currentY - startY;

      if (isHorizontalSwipe === null) {
        if (Math.abs(deltaX) > 5 || Math.abs(deltaY) > 5) {
          isHorizontalSwipe = Math.abs(deltaX) > Math.abs(deltaY);
        }
      }

      if (isHorizontalSwipe) {
        if (e && e.cancelable) e.preventDefault();
        dragDistance = deltaX;
        const currentOffset = -getSlideOffset(currentIndex);

        // Edge dampening
        let adjustedDelta = deltaX;
        const maxIdx = getMaxIndex();
        if ((currentIndex === 0 && deltaX > 0) || (currentIndex === maxIdx && deltaX < 0)) {
          adjustedDelta = deltaX * 0.25;
        }

        list.style.transform = `translateX(${currentOffset + adjustedDelta}px)`;
      }
    }

    function endDrag() {
      if (!isDragging) return;
      isDragging = false;
      track.style.cursor = 'grab';
      list.style.transition = 'transform 0.35s cubic-bezier(0.25, 1, 0.5, 1)';

      const threshold = 35;
      const maxIdx = getMaxIndex();

      if (dragDistance < -threshold && currentIndex < maxIdx) {
        goToIndex(currentIndex + 1);
      } else if (dragDistance > threshold && currentIndex > 0) {
        goToIndex(currentIndex - 1);
      } else {
        goToIndex(currentIndex);
      }
    }

    // Touch events
    track.addEventListener('touchstart', (e) => {
      if (e.target.closest('.drevit-video-sound-btn')) return;
      if (e.touches.length === 1) {
        startDrag(e.touches[0].clientX, e.touches[0].clientY);
      }
    }, { passive: true });

    track.addEventListener('touchmove', (e) => {
      if (e.touches.length === 1) {
        moveDrag(e.touches[0].clientX, e.touches[0].clientY, e);
      }
    }, { passive: false });

    track.addEventListener('touchend', endDrag, { passive: true });
    track.addEventListener('touchcancel', endDrag, { passive: true });

    // Mouse events
    track.addEventListener('mousedown', (e) => {
      if (e.target.closest('.drevit-video-sound-btn')) return;
      if (e.button !== 0) return;
      startDrag(e.clientX, e.clientY);
      e.preventDefault();
    });

    window.addEventListener('mousemove', (e) => {
      if (isDragging) {
        moveDrag(e.clientX, e.clientY, e);
      }
    });

    window.addEventListener('mouseup', () => {
      if (isDragging) {
        endDrag();
      }
    });

    // Prevent click on drag
    track.addEventListener('click', (e) => {
      if (Math.abs(dragDistance) > 8) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    // Initial setup
    buildDots();
    goToIndex(0, false);

    // Handle resize
    let resizeTimer = null;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        buildDots();
        goToIndex(Math.min(currentIndex, getMaxIndex()), false);
      }, 100);
    });
  });
});

